export default __webpack_public_path__ + "static/media/no.d74ca619.mp3";